import useRouter from '~/client/hooks/router/useRouter';
import useIsLoggedIn from '~/client/hooks/user/useIsLoggedIn';
import type { LinkProps } from '~/client/shared/NextLink';
import useGameParams from './useGameParams';

const useGameLoginProtected = () => {
  const redirectTo = useLoginProtected();
  return { redirectTo };
};

const useLoginProtected = (): Maybe<LinkProps['href']> => {
  const { handle, categoryHandle } = useGameParams();
  const isLoggedIn = useIsLoggedIn();
  const router = useRouter();
  const requiresLogin = !isLoggedIn && isGameProtected(categoryHandle, handle);
  return requiresLogin
    ? { href: 'login', query: { redirectTo: router.asPath } }
    : undefined;
};

const isGameProtected = (categoryHandle?: string, handle?: string) =>
  (categoryHandle === 'poker' && handle === 'play-poker') ||
  (categoryHandle === 'virtual-sports' && handle === 'golden-race');

export default useGameLoginProtected;
